export const CHANGE_SECTION = 'CHANGE_SECTION';

export const changeSection = (section) => ({type: CHANGE_SECTION, section});

export const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';

const showTooltip = (tooltipId) => ({type: SHOW_TOOLTIP, tooltipId});

const hideTooltip = (tooltipId) => ({type: HIDE_TOOLTIP, tooltipId});

export const flashTooltip = (tooltipId) => (dispatch) => {
  dispatch(showTooltip(tooltipId));
  setTimeout(() => {
    dispatch(hideTooltip(tooltipId));
  }, 500);
};
